module.exports = __webpack_public_path__ + "img/icon-arrow-right.01a302c2.svg";